import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login, formatApiError } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#FAF9F6] px-4">
      <div className="w-full max-w-md">
        <div className="mb-8 flex justify-center"><Link to="/"><Logo /></Link></div>
        <div className="rounded-2xl border border-[#E5E2DC] bg-white p-8">
          <h1 className="font-head text-2xl font-semibold text-neutral-900">Welcome back</h1>
          <p className="mt-1 text-neutral-600">Let's pick up where you left off.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="mb-1.5 block text-sm font-medium text-neutral-700">Email</label>
              <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="min-h-[48px] w-full rounded-xl border border-neutral-200 px-4 outline-none transition-all focus:border-[var(--tenant-primary)] focus:ring-2 focus:ring-[var(--tenant-primary-light)]" placeholder="you@business.com" />
            </div>
            <div>
              <label className="mb-1.5 block text-sm font-medium text-neutral-700">Password</label>
              <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="min-h-[48px] w-full rounded-xl border border-neutral-200 px-4 outline-none transition-all focus:border-[var(--tenant-primary)] focus:ring-2 focus:ring-[var(--tenant-primary-light)]" placeholder="••••••••" />
            </div>
            {error && <p data-testid="login-error" className="text-sm text-[#D96C4A]">{error}</p>}
            <button data-testid="login-submit" disabled={loading} className="min-h-[48px] w-full rounded-full font-semibold text-white transition-all hover:-translate-y-0.5 disabled:opacity-60" style={{ backgroundColor: "var(--tenant-primary)" }}>
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>
          <p className="mt-6 text-center text-sm text-neutral-600">New here? <Link data-testid="to-register" to="/register" className="font-semibold tenant-text">Create a free account</Link></p>
        </div>
      </div>
    </div>
  );
}
